import { Property } from "./interfaces";

export const fechaInicioAtencion: Property = {
  title: "Fecha de Inicio de Atención",
  type: "string",
  format: "local-date-time",
};
